// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalBiDenial {
    'date'?: Moment;
    'number'?: string;
    'reason'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalBiDenial>> = [
        {
            "name":     "date",
            "baseName": "date",
            "type":     "Date"
        },
        {
            "name":     "number",
            "baseName": "number",
            "type":     "string"
        },
        {
            "name":     "reason",
            "baseName": "reason",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalBiDenial.attributeTypeMap;
    }
}
